import classNames from "classnames";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { dataUserSession } from "../../../utilities/dataSession";

export default function P220Search({ searchData, setSearchData, onSearch }) {
    const history = useHistory();

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";

        if (key === "requestType") {
            setSearchData({
                ...searchData,
                [`${key}`]: val,
                locationBegin: val === "A" ? 0 : searchData.locationBegin,
                locationEnd: val === "A" ? 0 : searchData.locationEnd,
            });
        } else {
            setSearchData({
                ...searchData,
                [`${key}`]: val,
            });
        }
    };

    // new 12/01/2022
    const [userRole] = useState(dataUserSession() && dataUserSession().userRole ? dataUserSession().userRole : "");

    const goBack = () => {
        if(userRole === "8" || userRole === '9'){
            history.push("/350");
        } else {
            history.push("/208");
        }
    };

    return (
        <>
            <div className="p-grid crud-demo">
                <div className="p-col-12">
                    {/* <div className="card"> */}
                    <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                        <div className="p-col-12 p-md-4">
                            <label htmlFor="inspectTime">เลขที่สัญญา</label>
                            <InputText type="text" placeholder="เลขที่สัญญา" disabled maxLength="20" value={searchData.contractNo} />
                        </div>
                        <div className="p-col-12 p-md-4">
                            <label htmlFor="inspectTime">เส้นทาง</label>
                            <InputText type="text" placeholder="เส้นทาง" disabled maxLength="200" value={searchData.routeName} />
                        </div>
                    </div>

                    <div className="p-grid p-fluid" style={{ marginBottom: -20 }}>
                        <div className="p-col-12 p-md-4">
                            {/* <div className="card"> */}
                            <label htmlFor="inspectTime">บริเวณงาน</label>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field-radiobutton">
                                        <RadioButton inputId="requestType_1" name="requestType_1" value="A" checked={searchData.requestType === "A" ? true : false} onChange={(e) => onInputTextChange(e, "requestType")} className={classNames({ "p-invalid": !searchData.requestType })} />
                                        <label htmlFor="requestType_1">ทั้งหมด</label>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field-radiobutton">
                                        <RadioButton inputId="requestType_2" name="requestType_2" value="D" checked={searchData.requestType === "D" ? true : false} onChange={(e) => onInputTextChange(e, "requestType")} className={classNames({ "p-invalid": !searchData.requestType })} />
                                        <label htmlFor="option2">เป็นช่วง</label>
                                    </div>
                                </div>
                            </div>
                            {/* </div> */}
                        </div>

                        <div className="p-col-12 p-md-2">
                            <label htmlFor="inspectTime">จาก</label>

                            <InputNumber
                                placeholder="จาก"
                                inputId="locationBegin"
                                value={searchData.locationBegin}
                                onValueChange={(e) => onInputTextChange(e, "locationBegin")}
                                mode="decimal"
                                max={9999999999}
                                minFractionDigits={2}
                                maxFractionDigits={2}
                                disabled={searchData.requestType === "A" ? true : false}
                                className={classNames({ "p-invalid": searchData.requestType === "D" })}
                            />

                            {/* {submitted && !dataTableA.inspectTime && validateInputText("inspectTime", "เวลาตรวจ")} */}
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="inspectTime">ถึง</label>
                            <span className="p-input-icon-right">
                                <InputNumber
                                    placeholder="ถึง"
                                    inputId="locationEnd"
                                    value={searchData.locationEnd}
                                    onValueChange={(e) => onInputTextChange(e, "locationEnd")}
                                    mode="decimal"
                                    max={9999999999}
                                    minFractionDigits={2}
                                    maxFractionDigits={2}
                                    disabled={searchData.requestType === "A" ? true : false}
                                    className={classNames({ "p-invalid": searchData.requestType === "D" })}
                                />
                                <i className="pi pi-clock" />
                            </span>
                            {/* {submitted && !dataTableA.inspectTime && validateInputText("inspectTime", "เวลาตรวจ")} */}
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div style={{ display: "flex", marginBottom: "10px" }}>
                                <Button className="p-button btn-srh-responsive" icon="pi pi-search" label="ค้นหา" style={{ marginTop: 25 }} onClick={() => onSearch(searchData)} />

                                <Button className="p-button-secondary p-button btn-long-responsive" icon="pi pi-arrow-left" label="กลับหน้าจอแสดงสัญญา" style={{ marginLeft: "5px", marginTop: 25 }} onClick={() => goBack()} />
                            </div>
                        </div>
                    </div>

                    {/* <div className="p-grid p-fluid" style={{ marginBottom: -30 }}>
                            
                            <div className="p-col-12 p-md-2">
                                <label htmlFor="inspectTime">จาก</label>
                               
                                <InputNumber 
                                    placeholder="จาก"
                                    inputId="locationBegin" 
                                    value={searchData.locationBegin}
                                    onValueChange={(e) => onInputTextChange(e, "locationBegin")}
                                    mode="decimal" 
                                    max={9999999999}
                                    minFractionDigits={2} maxFractionDigits={2} 
                                    disabled={searchData.requestType === 'A'?true:false}
                                    className={classNames({ "p-invalid": (searchData.requestType==='D') })}
                                />
                            </div>
                            <div className="p-col-12 p-md-2">
                                <label htmlFor="inspectTime">ถึง</label>
                                <span className="p-input-icon-right" >
                                    <InputNumber 
                                        placeholder="ถึง"
                                        inputId="locationEnd" 
                                        value={searchData.locationEnd}
                                        onValueChange={(e) => onInputTextChange(e, "locationEnd")}
                                        mode="decimal" 
                                        max={9999999999}
                                        minFractionDigits={2} maxFractionDigits={2} 
                                        disabled={searchData.requestType === 'A'?true:false}
                                        className={classNames({ "p-invalid": (searchData.requestType==='D') })}
                                    />
                                    <i className="pi pi-clock" />
                                </span>
                            </div>
                            <div className="p-field p-col-12 p-md-6">
                                <div style={{ display: 'flex', marginBottom : '10px'}} >
                                    <Button
                                        className="p-button btn-srh-responsive"
                                        icon="pi pi-search"
                                        label="ค้นหา"
                                        // style={{ width: 130 }}
                                        onClick={() => onSearch(searchData)} 
                                    />

                                    <Button
                                        className="p-button-danger p-button btn-long-responsive"
                                        icon="pi pi-times"
                                        label="กลับหน้าจอแสดงปัญหา"
                                        style={{  marginLeft: '5px' }}
                                        onClick={() => { history.push('/208') }} 
                                    />
                                   
                                </div>
                            </div>
                        </div> */}

                    <div className="p-grid p-fluid" style={{ marginBottom: "20px" }}>
                        <div className="p-col-12 p-md-12">
                            <hr />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
